import React from "react";
import { Link } from 'react-router-dom';

import { getFirestoreData, updateFirestoreWithOneObject } from 'store/actions/firestoreActions.jsx'
import { startSetUser, updateUser } from 'store/actions/profileActions.jsx'
import moment from "moment"
import { db, firebase } from "firebase/fbConfig.js"
import Button from "components/CustomButtons/Button.jsx";

// Get Users for Users Panel
export const startSetOrdersList = (uid) => {
  return (dispatch) => {
    db.collection("orders")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data();
          console.log(docData.pickUpDate)
          var docObj = {
            id: String(doc.id),
            totalExpenses: docData.totalExpenses ? docData.totalExpenses : 0,
            totalRevenue: docData.totalRevenue ? docData.totalRevenue : 0,
            freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
            uid: docData.uid ? docData.uid : "N/A",
            shippingMode: docData.shippingMode ? docData.shippingMode : "N/A",
            origin: docData.origin ? docData.origin : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destination ? docData.destination : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
            financialStatus: docData.financialStatus ? docData.financialStatus : "N/A"
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setOrdersList(data))
      })
  }
}

export const startSetPendingOrdersList = (groups) => {

  if (!(groups && groups.length)) {
    return (dispatch) => dispatch(setPendingOrdersList([]));
  }

  return (dispatch) => {
    db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000)
      .get().then((snapshot) => {
        // origTotalExpenses: orderData.totalExpenses
        //<b>CM%:</b> {(this.state.cmPercent * 100).toFixed(2)}%//
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()

          // console.log(docData.pickUpDate)
          if (!docData.test && ["pending", "Pending"].includes(docData.status)) {

            const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
            const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
            const cmTotal = (revenue - expenses).toFixed(2);
            const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';

            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              billingParty: docData.billingParty ? docData.billingParty : "",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A"
            }
            data.push(docObj);
          }
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setPendingOrdersList(data))
      })
  }
}

export const startSetQuotedOrdersList = (groups) => {

  if (!(groups && groups.length)) {
    return (dispatch) => dispatch(setQuotedOrdersList([]));
  }

  return (dispatch) => {
    db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          // console.log(docData.pickUpDate)
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/a';
          if (!docData.test && ["quoted", "Quoted", "Quoted Needs Approval"].includes(docData.status)) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",

            }
            data.push(docObj);
          }
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setQuotedOrdersList(data))
      })
  }
}

export const startSetBookedOrdersList = (groups) => {

  if (!(groups && groups.length)) {
    return (dispatch) => dispatch(setBookedOrdersList([]));
  }

  return (dispatch) => {
    db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          // console.log( "cmTotal " + cmTotal)
          // console.log(docData.pickUpDate)
          if (!docData.test && ["booked", "Booked"].includes(docData.status)) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? ((docData.deliveryType == "Air") ? "Next Flight Out" : (docData.deliveryType == "Scheduled Air") ? "Next Day Air" : (docData.deliveryType == "Ground") ? "Dedicated Ground" : (docData.deliveryType == "Additional Options") ? "Additional Options" : "?") : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",

            }
            data.push(docObj);
          }
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setBookedOrdersList(data))
      })
  }
}


export const startSetDispatchedOrdersList = (groups) => {
  console.log(groups);
  if (!(groups && groups.length)) {
    return (dispatch) => dispatch(setDispatchedOrdersList([]));
  }
  return (dispatch) => {
    db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          if (!docData.test && ["dispatched", "Dispatched"].includes(docData.status)) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",
            }
            data.push(docObj);
          }
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setDispatchedOrdersList(data))
      })
  }
}

export const startSetDockedOrdersList = (groups) => {

  if (!(groups && groups.length)) {
    return (dispatch) => dispatch(setDockedOrdersList([]));
  }

  return (dispatch) => {
    db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          // console.log(docData.pickUpDate)
          if (!docData.test && ["docked", "Docked"].includes(docData.status)) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",

            }
            data.push(docObj);
          }
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setDockedOrdersList(data))
      })
  }
}


export const startSetInTransitOrdersList = (groups) => {

  if (!(groups && groups.length)) {
    return (dispatch) => dispatch(setInTransitOrdersList([]));
  }

  return (dispatch) => {
    db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          // console.log(docData.pickUpDate)
          if (!docData.test && ["In Route to Shipper", "Arrived at Shipper", "Driver Departed Shipper", "Aircraft Arrived", "Arrived at Airline", "Tendered to Airline Awaiting Departure", "Aircraft Departed", "Aicraft Arrived", "Aircraft Download", "In Route to Consignee", "Arrived at Consignee"].includes(docData.status)) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",

            }
            data.push(docObj);
          }
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setInTransitOrdersList(data))
      })
  }
}


export const startSetDriverDispatchedOrdersList = (uid) => {
  return (dispatch) => {
    db.collection("orders").where("status", "==", "dispatched").where('pickUpCarrier', '==', uid)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          const cmTotal = (parseFloat(docData.totalRevenue ? docData.totalRevenue : 0) - parseFloat(docData.totalExpenses ? docData.totalExpenses : 0));
          const cmPercent = (parseFloat(docData.cmTotal ? docData.cmTotal : 0) / parseFloat(docData.totalRevenue ? docData.totalRevenue : 0));
          const referenceID = docData.origin.referenceID + ", " + docData.destination.referenceID + "," + docData.thirdParty.referenceID
          // console.log(docData.pickUpDate)
          if (!docData.test) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: docData.totalExpenses ? docData.totalExpenses : 0,
              totalRevenue: docData.totalRevenue ? docData.totalRevenue : 0,
              cmTotal: parseFloat(cmTotal),
              cmPercent: parseFloat(cmPercent),
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : " "),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",

            }
            data.push(docObj);
          }
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setDispatchedOrdersList(data))
      })
  }
}


export const startSetConfirmedOrdersList = (groups) => {

  if (!(groups && groups.length)) {
    return (dispatch) => dispatch(setConfirmedOrdersList([]));
  }

  return (dispatch) => {
    db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          // console.log(docData.pickUpDate)
          if (!docData.test && ["completed", "delivered", "Delivered", "confirmed", "Arrived at Destination"].includes(docData.status)) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",

            }
            data.push(docObj);
          }
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setConfirmedOrdersList(data))
      })
  }
}

export const startSetCancelledOrdersList = (groups) => {

  if (!(groups && groups.length)) {
    return (dispatch) => dispatch(setCancelledOrdersList([]));
  }

  return (dispatch) => {
    db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          // console.log(docData.pickUpDate)
          if (!docData.test && ["canceled", "Canceled", "Cancel Requested", "Quote Declined"].includes(docData.status)) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",
            }
            data.push(docObj);
          }
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setCancelledOrdersList(data))
      })
  }
}

export const startSetAllOrdersList = (groupsProps) => {
  if (!(groupsProps.groups && groupsProps.groups.length)) {
    return (dispatch) => dispatch(setAllOrdersList([]));
  }
  console.log(groupsProps)
  return (dispatch) => {
    db.collection("haney-orders").where(groupsProps.isGroups ? "freightBillNumber" : "groups", groupsProps.isGroups ? ">" : "array-contains-any", groupsProps.isGroups ? 0 : groupsProps.groups).orderBy("updatedAt", "desc").limit(1000)
      // db.collection("haney-orders").orderBy("freightBillNumber", "desc")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.docs.forEach((doc) => {
          const commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          // console.log(doc.id);
          // console.log(docData.pickUpDate)
          if (groupsProps.isTest ? true : !docData.test) {
            var docObj = {
              id: String(doc.id),
              totalExpenses:"$" + commaFy(expenses),
              totalRevenue: "$" + commaFy(revenue),
              cmTotal: "$" + commaFy(cmTotal),
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key] ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              actualDeliveredAt: (docData.actualDeliveredAt ? moment(docData.actualDeliveredAt.toDate()).format('MM/DD/YYYY') : "N/A") + "h " + docData.nameOfSigner,
              class: docData.class ? docData.class : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              status: docData.status ? docData.status : "N/A",
              entityIDs: docData.entityIDs ? docData.entityIDs : [],
              vendorName: (docData.vendorPickUp && docData.vendorPickUp.name) ? docData.vendorPickUp.name : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              signingURLs: docData.signingURLs,
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",
              actions: (
                <Link to={{
                  pathname: `/order/${doc.id}`,
                  state: {
                    shipperID: doc.id,
                    status: docData.status
                  }
                }}>
                  <Button
                    color="primary"
                    fullWidth
                  >DETAILS</Button>
                </Link>
              )
            }
            data.push(docObj);
          }
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setAllOrdersList(data))
      })
  }
}

export const startSetPickupsOrdersList = (groupsProps) => {
  if (!(groupsProps.groups && groupsProps.groups.length)) {
    return (dispatch) => dispatch(setAllOrdersList([]));
  }
  console.log("pickups today")
  return (dispatch) => {
    db.collection("haney-orders").where(groupsProps.isGroups ? "origin.date" : "groups", groupsProps.isGroups ? ">" : "array-contains-any", groupsProps.isGroups ? 0 : groupsProps.groups).where("origin.date", "<=", new Date()).orderBy("origin.date", "desc").limit(1000)
      // db.collection("haney-orders").orderBy("freightBillNumber", "desc")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.docs.forEach((doc) => {
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          // console.log(doc.id);
          // console.log(docData.pickUpDate)

          if ((groupsProps.isTest ? true : !docData.test) && ["booked", "Booked", "dispatched", "Dispatched"].includes(docData.status)) {
            var docObj = {
              id: String(doc.id),
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              status: docData.status ? docData.status : "N/A",
              entityIDs: docData.entityIDs ? docData.entityIDs : [],
              vendorName: (docData.vendorPickUp && docData.vendorPickUp.name) ? docData.vendorPickUp.name : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              signingURLs: docData.signingURLs,
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",
              actions: (
                <Link to={{
                  pathname: `/order/${doc.id}`,
                  state: {
                    shipperID: doc.id,
                    status: docData.status
                  }
                }}>
                  <Button
                    color="primary"
                    fullWidth
                  >DETAILS</Button>
                </Link>
              )
            }
            data.push(docObj);
          }
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setAllOrdersList(data))
      })
  }
}

export const startSetDeliveriesOrdersList = (groupsProps) => {
  if (!(groupsProps.groups && groupsProps.groups.length)) {
    return (dispatch) => dispatch(setDeliveriesOrdersList([]));
  }
  console.log("deliveries todays")
  return (dispatch) => {
    db.collection("haney-orders").where(groupsProps.isGroups ? "serviceETA" : "groups", groupsProps.isGroups ? "!=" : "array-contains-any", groupsProps.isGroups ? "1234" : groupsProps.groups).where("serviceETA", "<=", new Date()).orderBy("serviceETA", "desc").limit(1000)
      // db.collection("haney-orders").orderBy("freightBillNumber", "desc")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.docs.forEach((doc) => {
          const docData = doc.data()
          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
          // console.log(doc.id);
          // console.log(docData.pickUpDate)
          if ((groupsProps.isTest ? true : !docData.test) && ["booked", "Booked", "dispatched", "Dispatched", "docked", "Docked", "In Route to Shipper", "Arrived at Shipper", "Driver Departed Shipper", "Aircraft Arrived", "Arrived at Airline", "Tendered to Airline Awaiting Departure", "Aircraft Departed", "Aicraft Arrived", "Aircraft Download", "In Route to Consignee", "Arrived at Consignee"].includes(docData.status)) {
            var docObj = {
              totalExpenses: expenses,
              totalRevenue: revenue,
              cmTotal,
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.serviceETA ? (moment(docData.serviceETA.toDate()).format('MM/DD/YYYY')) : (docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A"),
              class: docData.class ? docData.class : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              status: docData.status ? docData.status : "N/A",
              entityIDs: docData.entityIDs ? docData.entityIDs : [],
              vendorName: (docData.vendorPickUp && docData.vendorPickUp.name) ? docData.vendorPickUp.name : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              signingURLs: docData.signingURLs,
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",
              actions: (
                <Link to={{
                  pathname: `/order/${doc.id}`,
                  state: {
                    shipperID: doc.id,
                    status: docData.status
                  }
                }}>
                  <Button
                    color="primary"
                    fullWidth
                  >DETAILS</Button>
                </Link>
              )
            }
            data.push(docObj);
          }
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setDeliveriesOrdersList(data))
      })
  }
}



export const startSetFavoritedOrdersList = (uid) => {
  return (dispatch) => {
    db.collection("haney-orders").where('dispatcherID', '==', uid).orderBy("freightBillNumber", "desc").limit(1000).get()
      .then((snapshot) => {
        const data = []
        const statuses = {};
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          const docData = doc.data()

          if (docData.status && !statuses[docData.status]) statuses[docData.status] = true;

          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';

          // console.log(docData)
          if (!docData.test) {
            var docObj = {
              id: String(doc.id),
              totalExpenses:"$" + commaFy(expenses),
              totalRevenue: "$" + commaFy(revenue),
              cmTotal: "$" + commaFy(cmTotal),
              cmPercent,
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
              status: docData.status ? docData.status : "N/A",
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",
            }
            data.push(docObj);
          }
        })
        console.log(data)
        return { data, statuses };
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(({ data, statuses }) => {
        dispatch(setFavoritedOrdersList(data, Object.keys(statuses)))
      })
  }
}



export const startSetMyOrdersList = (uid) => {
  return (dispatch) => {
    db.collection("TEST-users").doc(uid).collection("orders")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          const docData = doc.data()
          console.log(docData.status)
          var docObj = {
            id: String(doc.id),
            uid: docData.uid ? docData.uid : "N/A",
            totalExpenses: docData.totalExpenses ? docData.totalExpenses : 0,
            totalRevenue: docData.totalRevenue ? docData.totalRevenue : 0,
            freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
            deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
            origin: docData.originZip ? docData.originZip : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destinationZip ? docData.destinationZip : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
            financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
            updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setOrdersList(data))
      })
  }
}

export const startSetTripOrdersList = (groupsProps) => {
  console.log(groupsProps);

  return (dispatch) => {
    db.collection('TEST-users').doc(groupsProps.authUser.uid).collection('haney-groups').get()
      .then(async snapshot => {

        const groups = snapshot.docs.map(doc => doc.id);

        const groupOrdersSnap = await db.collection("haney-orders").where("groups", "array-contains-any", groups).orderBy("freightBillNumber", "desc").limit(1000).get();
        // const groupOrdersSnap = await db.collection("haney-orders").where("groups", "array-contains-any", groups).where('deliveryType', 'in', ['LTL', 'Ground', 'Additional Options']).orderBy("freightBillNumber", "desc").get();
        const groupOrders = [];
        groupOrdersSnap.docs.map(doc => {
          const commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          const docData = doc.data();

          if (["canceled", "Canceled", "Cancel Requested", "Quote Declined"].includes(docData.status)) return null;

          const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
          const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
          const cmTotal = (revenue - expenses).toFixed(2);
          const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';

          const docObj = {
            id: String(doc.id),
            totalExpenses:"$" + commaFy(expenses),
            totalRevenue: "$" + commaFy(revenue),
            cmTotal: "$" + commaFy(cmTotal),
            cmPercent,
            referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key] ? docData[key].referenceID : "").filter(Boolean).join(', '),
            billingParty: docData.billingParty ? docData.billingParty : "",
            description: docData.description ? docData.description : "",
            freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
            originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
            originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
            originState: docData.originState ? docData.originState : "",
            destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
            destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
            destinationState: docData.destinationState ? docData.destinationState : "",
            uid: docData.uid ? docData.uid : "N/A",
            deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
            origin: docData.origin ? docData.origin : "N/A",
            pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destination ? docData.destination : "N/A",
            dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
            financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
            pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
            dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
            updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
            serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",
            entityIDs: docData.entityIDs ? docData.entityIDs : [],
            vendorName: (docData.vendorPickUp && docData.vendorPickUp.name) ? docData.vendorPickUp.name : "N/A",
            driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
            signingURLs: docData.signingURLs,
            groups: docData.groups ? docData.groups : [],
          }

          // console.log(docData.status.toLowerCase(), docData.freightBillNumber)
          // console.log(!['pending', 'quoted', 'delivered', 'cancelled', 'canceled', 'cancel requested', 'quote declined'].includes(docData.status.toLowerCase()))
          if (!docData.test && !['pending', 'Pending', 'Quoted', 'quoted', 'delivered', 'cancel requested', 'quote declined'].includes(docData.status.toLowerCase()) && ['LTL', 'Additional Options', 'Ground'].includes(docData.deliveryType)) groupOrders.push(docObj);
        }).filter(Boolean);

        console.log(groupOrders);

        dispatch(setAllOrdersList(groupOrders))
      })
  }
}



export const setOrdersList = (dataRows) => ({
  type: 'SET_ORDERS_LIST',
  dataRows
})


export const setPendingOrdersList = (dataRows) => ({
  type: 'SET_PENDING_ORDERS_LIST',
  dataRows
})


export const setQuotedOrdersList = (dataRows) => ({
  type: 'SET_QUOTED_ORDERS_LIST',
  dataRows
})

export const setBookedOrdersList = (dataRows) => ({
  type: 'SET_BOOKED_ORDERS_LIST',
  dataRows
})

export const setDispatchedOrdersList = (dataRows) => ({
  type: 'SET_DISPATCHED_ORDERS_LIST',
  dataRows
})

export const setInTransitOrdersList = (dataRows) => ({
  type: 'SET_INTRANSIT_ORDERS_LIST',
  dataRows
})

export const setDockedOrdersList = (dataRows) => ({
  type: 'SET_DOCKED_ORDERS_LIST',
  dataRows
})

export const setConfirmedOrdersList = (dataRows) => ({
  type: 'SET_CONFIRMED_ORDERS_LIST',
  dataRows
})

export const setCancelledOrdersList = (dataRows) => ({
  type: 'SET_CANCELLED_ORDERS_LIST',
  dataRows
})

export const setAllOrdersList = (dataRows) => ({
  type: 'SET_ALL_ORDERS_LIST',
  dataRows
})

export const setPickupsOrdersList = (dataRows) => ({
  type: 'SET_ALL_ORDERS_LIST',
  dataRows
})
export const setDeliveriesOrdersList = (dataRows) => ({
  type: 'SET_ALL_ORDERS_LIST',
  dataRows
})


export const setFavoritedOrdersList = (dataRows, statuses) => ({
  type: 'SET_FAVORITED_ORDERS_LIST',
  dataRows,
  statuses
})

startSetBookedOrdersList



// WEBPACK FOOTER //
// ./src/store/actions/ordersActions.jsx